const FillPersonIcon = ({
  size = 25,
  fill = 'white',
}: {
  size?: number | string;
  fill?: string;
}) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 25 25"
        fill="none"
      >
        <path
          d="M12.5 2.41113C13.8261 2.41113 15.0979 2.93792 16.0355 3.8756C16.9732 4.81328 17.5 6.08505 17.5 7.41113C17.5 8.73722 16.9732 10.009 16.0355 10.9467C15.0979 11.8843 13.8261 12.4111 12.5 12.4111C11.1739 12.4111 9.90215 11.8843 8.96447 10.9467C8.02678 10.009 7.5 8.73722 7.5 7.41113C7.5 6.08505 8.02678 4.81328 8.96447 3.8756C9.90215 2.93792 11.1739 2.41113 12.5 2.41113ZM12.5 14.9111C18.025 14.9111 22.5 17.1486 22.5 19.9111V22.4111H2.5V19.9111C2.5 17.1486 6.975 14.9111 12.5 14.9111Z"
          fill={fill}
        />
      </svg>
    </>
  );
};

export default FillPersonIcon;
